<template>
    <div class="signup container">
        <div class="row card-panel" style="padding: 30px;" v-if="success">
            <div class="col-12">
                <div class="row" style="margin-top: 75px">
                    <div class="col-12 center">
                        <h2 class="teal-text">Success!</h2>
                        <p>A login link has been sent to: <span class="teal-text">{{ email }}</span>.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="padding: 30px;">
            <div class="col-12" v-if="!success">
                <form @submit.prevent="signup" class="card-panel">
                    <h2 class="center teal-text">Sign Up/Login</h2>
                    <div class="field">
                        <label for="email">Email:</label>
                        <input type="email" name="email" v-model="email">
                    </div>
                    <p class="red-text center" v-if="feedback">{{ feedback }}</p>
                    <div class="field center">
                        <button class="btn teal" :disabled="processing">Sign In</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'
import firebase from 'firebase'
import functions from 'firebase/functions'

export default {
    name: 'Signup',
    data() {
        return {
            email: null,
            password: null,
            alias: null,
            feedback: null,
            slug: null,
            actionCodeSettings: {
                url: window.location.protocol + '//' + window.location.host + '/finishsignup',
                handleCodeInApp: true,
            },
            success: false,
            processing: false,
        }
    },
    methods: {
        signup(){
            this.processing = true;
            this.feedback = null;
            //WITHOUT FIREBASE FUNCTION
            if(this.email) {
                const email_address = this.email.toLowerCase();
                let idx = email_address.lastIndexOf('@');
                // if (idx > -1 && (email_address.slice(idx + 1) === 'pnoconsultants.com' || email_address.slice(idx + 1) === 'nehem.nl' || email_address.slice(idx + 1) === 'ttopstart.com' || email_address.slice(idx + 1) === 'inventivenl.nl' || email_address.slice(idx + 1) === 'innflow.eu' || email_address.slice(idx + 1) === 'ffiqs.com' || email_address.slice(idx + 1) === 'egen.green' || email_address.slice(idx + 1) === 'arttic.eu' || email_address.slice(idx + 1) === 'burdd.com' || email_address.slice(idx + 1) === 'pno.group' || email_address.slice(idx + 1) === 'cloudselling.nl' || email_address.slice(idx + 1) === 'burdock.com' || email_address.slice(idx + 1) === 'fagus-pme.nl' || email_address.slice(idx + 1) === 'pnochemistry.com' || email_address.slice(idx + 1) === '@grant-assurance.com')) {
                 if (idx > -1 && (email_address.slice(idx + 1) === 'pnoinnovation.com' || email_address.slice(idx + 1) === 'nehem.nl' || email_address.slice(idx + 1) === 'inventivenl.nl' || email_address.slice(idx + 1) === 'burdd.com' || email_address.slice(idx + 1) === 'burdock.com' || email_address.slice(idx + 1) === 'fagus-pme.nl' || email_address.slice(idx + 1) === 'pnochemistry.com')) { 
                    firebase.auth().sendSignInLinkToEmail(email_address, this.actionCodeSettings).then(function() {
                        // The link was successfully sent. Inform the user.
                        // Save the email locally so you don't need to ask the user for it again
                        // if they open the link on the same device.
                        window.localStorage.setItem('emailForSignIn', email_address);
                        window.location.href = window.location.protocol + '//' + window.location.host + '/emaillink?e=' + email_address;
                    })
                    .catch(function(error) {
                        console.log(error)
                        // Some error occurred, you can inspect the code: error.code
                        this.feedback = error;
                    });
                } else {
                    this.feedback = "Only PNO group E-Mail adresses are allowed. Please note that the email addresses have been changed to the new PNO Innovation domain. Try logging in with your @pnoinnovation.com e-mail instead.";
                    this.processing = false;
                }
            } else {
                this.feedback = "Please provide an email"
                this.processing = false;
            }

        }
    },
    mounted() {

    }
}
</script>

<style>
    .signup {
        max-width: 400px;
        margin-top: 60px;;
    }
    .signup h2 {
        font-size: 1.4em;
    }
    .signup .field{
        margin-bottom: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/Signup.vue